<template lang="pug">
  v-container(grid-list-lg, text-xs-center)
    v-layout(row, wrap, class="d-flex justify-center mt-5")
      v-flex(xs10 sm5 md5 mb-5 class="elevation-10 ", style='background-color:white')
          h1(class="text-center") Iniciar Sesión
          v-flex(xs12)
              v-row(align="center")
                  v-text-field(class="px-5" id="correo"
                    v-model="form.correo"
                    required
                    outlined
                    label="Usuario")
          v-flex(xs12)
              v-row(align="center")
                  v-text-field(class="px-5" id="contrasenna"
                    type="password"
                    v-model="form.contrasenna"
                    required
                    outlined
                    label="Contraseña")
          v-container(class="d-block")
              v-row
                v-col(cols="12" lg="12")
                  div(align="center" justify="center" class="px-1")
                     v-btn(color="success" block dark, @click.native='login') Entrar
              //- v-row
              //-   v-col(cols="12" lg="12")
              //-     div(align="center" justify="center")
              //-        v-btn(color="success" block dark, @click.native='registrar') Registrarse
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'login',
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    form: {
      correo: null,
      contrasenna: null
    }
  }),
  created () {
    this.initialize()
    if (this.$store.state.isUserLoggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    initialize () {},
    login () {
      Api.post('login', this.form)
        .then(res => {
          if (res.data.status === 'Success') {
            this.$store.dispatch('login', res.data)
            this.$socket.emit('userjoin', res.data.usuario._id)
            this.$cookies.set('token', res.data.token, '5D', '')
            window.location.href = '/EmpresaSeleccionada'
          } else {
            this.$swal(
              'Oops...',
              'Error encontrado, usuario o contraseña incorrecta.',
              'error'
            )
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al entrar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    registrar () {
      window.location.href = '/Registrar'
    }
  }
}
</script>
